<template>
<div style="margin:0 auto;width: 960px;background: #fff;height: 100%" >
  <div id="relatedTransactionsWrapper" class="mb-2">
	<div class="card mt-4">
                        <div class="card-header">
                            <div class="card-title">
                                <h4>트랜잭션 흐름</h4>
                            </div>
                        </div>
                        <div class="card-body p-0">
                            <table class="table table-flush align-middle table-row-bordered table-row-solid gy-4 gs-9">
                                <thead>
                                    <tr>
                                        <th>번호</th>
                                        <th>관련 번호</th>
                                        <th>타입</th>
                                      
                                        <th>변동</th>
                                        <th>변동후</th>
                                        <th>처리시각</th>
                                        <th>행위</th>
                                    </tr>
                                </thead>
                                <tbody>
                            <tr  v-for="(item,index) in orders" :key="index" :index="index">
                                <td>{{item.txid}}</td>
                                <td>{{item.round_id}}</td>
                                <td>{{item.tx_type}}</td>
                               
                                <td>{{formatMoney(item.bet)}}</td>
                                <td>{{formatMoney(item.balance)}}</td>
                                <td>{{item.game_time}}</td>
                                <td>{{txtypeObj[item.tx_type]}}</td>
                            </tr>
                        
                        </tbody>
                            </table>
                        </div>
                    </div>
    </div>
    
		<div id="userBettingWrapper" class="mb-2">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                <h4>유저 베팅</h4>
                            </div>
                        </div>
                        <div class="card-body p-0">
                            <table class="table table-flush align-middle table-row-bordered table-row-solid gy-4 gs-9" id="userBetsTable">
                                <thead>
                                    <tr>
                                        <th>베팅픽</th>
                                    
                                        <th>베팅 금액</th>
                                        <th>당첨 금액</th>
                                        <th>베팅 시각</th>
                                    </tr>
                                </thead>
                                <tbody><tr v-for="(item,index) in bets" :key="index" :index="index">
                                  <td>{{item.code}}</td><td>{{formatMoney(item.stake)}}</td><td>{{formatMoney(item.payout)}}</td><td>{{item.placedOn}}</td></tr></tbody>
                            </table>
                        </div>
                    </div>
                </div>	
                <div id="gameResultWrapper" class="mb-2" >
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                <h4>게임 결과</h4>
                            </div>
                        </div>
                        <div class="card-body">
                            <table class="table table-flush align-middle table-row-bordered table-row-solid gy-4 gs-9" id="gameResultTable">
                                <thead>
                                  <tr>
                                    <th>banker (스코어: {{banker.score}})</th>
                                    <th>player (스코어: {{player.score}})</th></tr>
                                  </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <img v-for="(item,index) in banker_cards" :key="index" :index="index" :src="'https://contents.slotsdiamond.com/public/uploads/card_deck/'+item+'.png'">
                                     
                                    </td>
                                    <td><img v-for="(item,index) in player_cards" :key="index" :index="index" :src="'https://contents.slotsdiamond.com/public/uploads/card_deck/'+item+'.png'">
                                    
                                    </td>
                                  </tr>
                                    <tr><th>결과</th><td>{{outcome}}</td></tr></tbody>
                            </table>
                        </div>
                    </div>
                </div>	
                <div id="gameInfoWrapper" class="mb-2" style="">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                <h4>게임 정보</h4>
                            </div>
                        </div>
                        <div class="card-body p-0">
                            <table class="table table-flush align-middle table-row-bordered table-row-solid gy-4 gs-9">
                                <tbody>
                                    <tr>
                                        <th>소속 에이전트</th>
                                        <td><span id="detailsAgentName">{{agent}}</span></td>
                                    </tr>
                                    <tr>
                                        <th>유저</th>
                                        <td><span id="detailsUser">{{mem_id}}</span></td>
                                    </tr>
                                    <tr>
                                        <th>게임사</th>
                                        <td><span id="detailsProvider">{{gameProvider}}</span></td>
                                    </tr>
                                    <tr>
                                        <th>딜러</th>
                                        <td><span id="detailsDealer">{{dealer.name}}</span></td>
                                    </tr>
                                    <tr>
                                        <th>테이블</th>
                                        <td><span id="detailsTableName">{{table.name}}</span></td>
                                    </tr>
                                    <tr>
                                        <th>시작 시각</th>
                                        <td><span id="detailsStartedAt">{{startedAt}}</span></td>
                                    </tr>
                                    <tr>
                                        <th>마감 시각</th>
                                        <td><span id="detailsSettledAt">{{settledAt}}</span></td>
                                    </tr>
                                    <tr>
                                        <th>게임 상태</th>
                                        <td><span id="detailsStatus">{{status}}</span></td>
                                    </tr>
                                   <!--  <tr>
                                        <th>처리 시각</th>
                                        <td><span id="detailsProcessedAt">2023-05-26 01:18:39</span></td>
                                    </tr> -->
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
</div>
 </template>

 <script>
 
    export default {
   
       props:{
      //接收父组件传来的id值
      info:{
        type:Object,
        default:()=>{
          return {}
        }
      },
       bets:{
        type:Array,
        default:()=>{
          return {}
        }
      },
       banker:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      player:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      gameProvider:{
        type:String,
        default:""
      },
     mem_id:{
        type:String,
        default:""
      },
      agent:{
        type:String,
        default:""
      },
        outcome:{
        type:String,
        default:""
      },
       dealer:{
        type:Object,
        default:()=>{
          return {}
        }
      },
       table:{
        type:Object,
        default:()=>{
          return {}
        }
      },
       banker_cards:{
        type:Array,
        default:()=>[]
        
      },
      player_cards:{
        type:Array,
        default:()=>[]
        
      },
       orders:{
        type:Array,
        default:()=>[]
        
      },
     status:{
        type:String,
        default:""
      },
       settledAt:{
        type:String,
        default:""
      },
       startedAt:{
        type:String,
        default:""
      },
    },
    	data(){
    		return{
    			domain:window.sessionStorage.getItem('domain'),
          power:window.sessionStorage.getItem('power'),
    		  txtypeObj:{
                    'bet':'당첨금',
                    'win':'베팅',
                },
			       
			         
    			}
    			
    			
    		},
    		created() {
        
          console.log('id',this.info.id)
         
    },
    	
    	methods:{
          
    	

    		
    		
    	
    	
    	
    		
    	}
  }
</script>

 <style scoped>
.card-body{
  padding:0;
}
  #gameResultWrapper img {
    width: 100px;
    border:1px solid #333;border-radius:5px;
    margin-right: 10px;}
  .card {
    font-size: 14px;
    border: 1px dashed #e8e5dd;
    box-shadow: none;
    position: relative;
    display: flex;
    flex-direction: column;
    word-wrap: break-word;
    background-color: rgba(248,246,242,.3);
    background-clip: border-box;
    border-radius: 0.95rem;
}
.card .card-header {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    flex-wrap: wrap;
    min-height: 70px;
    padding: 0 2.25rem;
    background-color: transparent;
    border-bottom: 1px dashed #e8e5dd
}

.card .card-header .card-title {
    display: flex;
    align-items: center;
    margin: .5rem;
    margin-left: 0
}
.card .card-header .card-title h4{font-size: 18px;color: #211f1c;font-weight: bold;}
.card .card-header .card-title.flex-column {
    align-items: flex-start;
    justify-content: center
}

.table.gs-9 td:first-child,.table.gs-9 th:first-child {
    padding-left: 2.25rem
}

.table.gs-9 td:last-child,.table.gs-9 th:last-child {
    padding-right: 2.25rem
}

.table.gs-9 td.dtr-control:first-child,.table.gs-9 th.dtr-control:first-child {
    padding-left: 2.25rem!important
}

</style>


// WEBPACK FOOTER //
// src/components/common/betting-details.vue